import axios from 'axios';
import { ActionTypes } from '../constants/actionTypes.js';
let getAccessTokenSilentlyFn = null;
export const setAuth0TokenGetter = (fn) => {
  getAccessTokenSilentlyFn = fn;
}

export const api = axios.create({
  baseURL: '',
  timeout:10000,  
  });

  //const MAX_RETRIES = 3;

    api.interceptors.request.use(async(config) => {
      if(getAccessTokenSilentlyFn) {
        const token = await getAccessTokenSilentlyFn({
          authorizationParam : {
            audience : 'https://gccp-APIAuthorization'
          }
        });
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    });

export const setupAxiosInterceptors = (dispatch) => {
api.interceptors.response.use(
  response => response,
  async error => {
    const config = error.config;
    //Retry logic for network errors or 5xx responses
    if(config?.retryCount === undefined) {
      config.retryCount = 0;
    }

    // if (
    //   config.retryCount < MAX_RETRIES &&
    //   (!error.response || error.response.status >= 500 || error.response.status === 404)
    // ) {
    //   config.retryCount += 1;
    //   const delay = Math.pow(2, config.retryCount) * 100;
    //   await new Promise(res => setTimeout(res, delay));

    //   return api(config);
    // }
    if (error?.config?.skipInterceptor) {
      throw error;
    }
    if(error?.name === 'CanceledError') {
      return;
    } else {
    const status = error.response?.status;
    switch (status) {
      case 400:
      case 404:
      case 500:
      case 503:
        dispatch({
        type: ActionTypes.STATUS_TOASTMESSAGE,
        payload: { open: true, message: "Something went wrong! Please try again.", status: "error" }
      });
        break;
      case 401:
        dispatch({
        type: ActionTypes.STATUS_TOASTMESSAGE,
        payload: { open: true, message: "Unauthorized. Please log in again.", status: "error" }
      });
        break;
      case 403:
        dispatch({
        type: ActionTypes.STATUS_TOASTMESSAGE,
        payload: { open: true, message: 'Forbidden. You do not have access.', status: "error" }
      });
      break;
      // case 404:
      //   displayToastMessage('Resource not found.');
      //   break;
      // case 500:
      //   displayToastMessage('Internal Server Error. Please try again later.');
      //   break;
      // case 503:
      //   displayToastMessage('Service Unavailable. Please try again later.');
      //   break;
      default:
        dispatch({
        type: ActionTypes.STATUS_TOASTMESSAGE,
        payload: { open: true, message: 'An unexpected error occurred.', status: "error" }
      });
        break;
    }
  }
   throw error;
 }
);
}

